export default "__VITE_ASSET__fa3cece4__"